import smalllogo from 'assets/app_logo.png';
import React from "react";


const LayoutView: React.FC = () => {



  return (
    <div
          style={{
            display: "flex",
            justifyContent: "center", // horizontal center
            alignItems: "center",     // vertical center
            height: "100vh",          // full viewport height
          }}
        >
          <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center', // vertical center
        alignItems: 'center',     // horizontal center
        height: '100%',           // take full available space
        minHeight: '200px',       // ensure visible center even with small tables
      }}
    >
      <img src={smalllogo} alt="Loading..." style={{ width: 150, marginBottom: 16 }} />
      
    </div>
        
        
        </div>
  );
};

export default LayoutView;